
/****PLEASE DON'T MAKE CHANGES IN THIS FILE IT'S AFFECT THE CODE IF YOU NEED ANY HELP PLEASE CONTACT TO FLITS TEAM support@getflits.com ****/
(function(Flits) {
  /* To load js in all pages */
  if(window.flitsObjects.allCssJs.socialLoginJs){
        Flits.LoadStyleScript('socialLoginJs',window.flitsObjects.allCssJs.socialLoginJs.url);
    }
  
  document.addEventListener('Flits:myProfile:Loaded', function (e) {
    if(location.pathname.indexOf("/account") != -1){
      Flits(".flits-menu-item a[href$='/account/logout']").attr("data-no-instant","");
    }
  });
  
  
  Flits(document).on('Flits:AccountPage:Visible', function(event){  
//     Flits.accountSettings.colorSettings.navigationBGColor = 'rgb(77, 161, 235)';
  });
}(Flits));
